import React from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';
import authService from '../services/authService';
import BinIcon from './icons/BinIcon';
import UsersIcon from './icons/UsersIcon';
import SettingsIcon from './icons/SettingsIcon';
import FileIcon from './icons/FileIcon';
const DocsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <line x1="16" y1="12" x2="8" y2="12" />
    <line x1="16" y1="16" x2="8" y2="16" />
  </svg>
);
// Depot style icon (warehouse building)
const SiteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 48 48" stroke="currentColor" fill="none" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20 24 8l20 12v18c0 2.4-1.9 4.4-4.2 4.4H8.2C5.9 42.4 4 40.4 4 38Z" fill="currentColor" fillOpacity="0.10" />
    <path d="M4 20 24 8l20 12" />
    <path d="M12 42V26h24v16" />
    <rect x="20" y="30" width="8" height="8" rx="1.2" fill="currentColor" fillOpacity="0.22" />
  </svg>
);

const LogsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const Sidebar = () => {
  const { t } = useI18n();
  const currentUser = authService.getCurrentUser();
  const role = currentUser?.role;
  const canSeeSettings = role === 'admin' || role === 'manager';
  const canSeeLogs = role === 'admin';
  const canSeeFiles = role === 'admin';
  return (
    <aside className="app-sidebar">
      <nav>
        <ul>
          <li>
            <NavLink to="/bins" className={({ isActive }) => (isActive ? 'active' : '')}>
              <BinIcon />
              <span>{t('menu.bins')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/sites" className={({ isActive }) => (isActive ? 'active' : '')}>
              <SiteIcon />
              <span>{t('menu.sites')}</span>
            </NavLink>
          </li>
          {canSeeFiles && (
            <li>
              <NavLink to="/file-management" className={({ isActive }) => (isActive ? 'active' : '')}>
                <FileIcon size={16} />
                <span>{t('menu.fileManagement') || 'Fájlok'}</span>
              </NavLink>
            </li>
          )}
          <li>
            <NavLink to="/users" className={({ isActive }) => (isActive ? 'active' : '')}>
              <UsersIcon />
              <span>{t('menu.users')}</span>
            </NavLink>
          </li>
          {canSeeSettings && (
            <li>
              <NavLink to="/settings" className={({ isActive }) => (isActive ? 'active' : '')}>
                <SettingsIcon />
                <span>{t('menu.settings')}</span>
              </NavLink>
            </li>
          )}
          {canSeeLogs && (
            <li>
              <NavLink to="/logs" className={({ isActive }) => (isActive ? 'active' : '')}>
                <LogsIcon />
                <span>{t('menu.logs') || 'Logok'}</span>
              </NavLink>
            </li>
          )}
          {/* Dokumentáció mindig UTOLSÓ menüpont */}
          <li>
            <NavLink to="/docs" className={({ isActive }) => (isActive ? 'active' : '')}>
              <DocsIcon />
              <span>{t('menu.docs') || 'Dokumentáció'}</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;